import { Input } from '@chakra-ui/react'
import { FC, useState } from 'react'

import useMrpDistribution from '@hook/mrp/use-distribution'

import LayoutToolsButton from '../../Components/Button'

const ActionMrpDistributionUpload: FC = () => {
  const [isLoading, setLoading] = useState(false)
  const { postUpload } = useMrpDistribution()

  const handleClick = () => {
    const inputValue = document.querySelector<HTMLInputElement>(
      '#distribution-upload'
    )

    inputValue.value = ''
    inputValue!.click()
  }

  return (
    <>
      <LayoutToolsButton
        label="Upload de arquivo"
        isLoading={isLoading}
        loadingText="Fazendo upload"
        onClick={handleClick}
      />
      <Input
        id="distribution-upload"
        d="none"
        type="file"
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        onChange={event => {
          postUpload(event)
          setLoading(true)

          setTimeout(() => {
            setLoading(false)
          }, 2000)
        }}
      />
    </>
  )
}

export default ActionMrpDistributionUpload
